
import { Component, Prop, Vue } from 'vue-property-decorator'
import { emojiList, emojiListEnglist } from '@/utils/const'
import EmojiImg from '@/components/emoji-img.vue'

@Component({
    components: {
        EmojiImg
    }
})
export default class UserMsg extends Vue {
    @Prop()
    message!: string

    emojiList = this.$i18n.locale === 'en_US' ? emojiListEnglist : emojiList

    get isEmoji() {
        for (let i = 0, j = this.emojiList.length; i < j; i++) {
            const emojiText = this.emojiList[i]
            const reg = new RegExp(`\\[${emojiText}\\]`, 'g')
            if (reg.test(this.message)) return true
        }
        return false
    }

    getImgUrl(message: string) {
        const emojiText = message.replace(/[\[\]]/g, '')
        const index = emojiList.findIndex(obj => obj === emojiText)
        if (index !== -1) {
            const url = require(`@/assets/emoji/smiley_${index}.png`)
            return url
        } else {
            return ''
        }
    }
}
